import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Button,
	Col,
	Divider,
	Form,
	message,
	Row,
	Spin,
	Typography,
	Upload,
	Modal
} from 'antd';
import InputComponent from '../../../../component/InputComponent';
import { templeRequest } from '../../../../request/AuthRequest';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
const { Title } = Typography;

const TempleImageUpload = observer((props) => {
	const {
		handleChange,
		onFinish,
		id,
		form,
		fileLists,
		setFileLists,
		initialValues,
		viewMode,
	} = props;
	const { AUTH, TEMPLE } = useStore();

	const validateFile = (file) => {
		const isCorrectFile = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/jfif'].includes(
			file.type
		);
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isCorrectFile) {
			message.error(`${file.name} is not a valid IMAGE file`);
		}
		if (!isLt2M) {
			message.error('IMAGE file must be smaller than 2MB!');
		}
		return isCorrectFile && isLt2M;
	};

	const beforeUpload = (file, fieldName) => {
		if (validateFile(file)) {
			setFileLists((prev) => ({
				...prev,
				[fieldName]: [file], // Set the file for the current field
			}));
			return false; // Prevent automatic upload
		}
		return false; // Prevent automatic upload
	};

	// Handle file removal
	const handleRemove = (fieldName) => {
		const updated = { ...fileLists };
		delete updated[fieldName];
		const reIndexed = Object.keys(updated).reduce((acc, key, idx) => {
			acc[idx] = updated[key];
			return acc;
		}, {});
		setFileLists(reIndexed);
		handleChange();
	};


	useEffect(() => {
		AUTH.getAllByLookupKeyList(`lookupKey=IMAGETYPE&isAdmin=false`);
	}, []);

	// Do not delete this console please
	console.log('AUTH.lookupKeyList', AUTH.lookupKeyList);

	const templeImageList = form.getFieldValue('templeImageList') || [];
	const selectedImageTypes = templeImageList.map(item => item?.ImageType).filter(type => type !== undefined && type !== null);
	const isImageType3Selected = selectedImageTypes.includes(3);


	return (
		<div>
			<Form
				id={id}
				layout="vertical"
				form={form}
				onFinish={onFinish}
				autoComplete="off"
				onChange={handleChange}
				initialValues={initialValues}
				disabled={viewMode}
			>
				<Spin
					spinning={
						!form.getFieldValue('templeImageList') && viewMode
					}
				>
					<Row gutter={24}>
						<Col span={24}>
							<Form.List name="templeImageList">
								{(fields, { add, remove }) => {
									return (
										<>
											<Row>
												{fields.map(
													({ key, name, ...restField }) => {
														const showConfirm = (name) => {
															Modal.confirm({
																title: "Are you sure you want to delete " + form.getFieldValue('templeImageList')[key].Description + " image ?",
																okText: "Yes",
																cancelText: "No",
																okButtonProps: {
																	style: {
																		backgroundColor: "ff6f00",
																		borderColor: "ff6f00",
																		color: "#fff",
																	},
																},
																onOk() {
																	handleImageDelete(name);
																},
															});
														};
														const handleImageDelete = (name) => {
															let curruntTempleImageDetails =
																TEMPLE?.templeImageDetails?.find(
																	(
																		_x,
																		index
																	) =>
																		index ===
																		name
																);
															if (
																curruntTempleImageDetails
															) {
																AUTH.onRemoveImage(
																	curruntTempleImageDetails.id,
																	curruntTempleImageDetails.versionNo
																).then(
																	(
																		data
																	) => {
																		let tempStateData =
																		{
																			...fileLists,
																		};
																		delete tempStateData[
																			name
																		];
																		const reIndexedData =
																			Object.keys(
																				tempStateData
																			)
																				.map(
																					(
																						key
																					) =>
																						tempStateData[
																						key
																						]
																				)
																				.reduce(
																					(
																						acc,
																						value,
																						index
																					) => {
																						acc[
																							index
																						] =
																							value;
																						return acc;
																					},
																					{}
																				);
																		setFileLists(
																			reIndexedData
																		);
																		TEMPLE.templeImageDetails =
																			TEMPLE.templeImageDetails.filter(
																				(
																					_x,
																					index
																				) =>
																					index !==
																					name
																			);
																		if (
																			typeof data ===
																			'string'
																		) {
																			remove(
																				name
																			);
																		}
																	}
																);
															} else {
																remove(
																	name
																);
																handleRemove(
																	name
																);
															}
															handleChange();
														}
														// })}

														return (
															<Col span={24} key={key}>
																<Row
																	gutter={24}
																	align={'bottom'}
																>
																	<Col span={6}>
																		<InputComponent
																			required
																			type="select"
																			showSearch={
																				true
																			}
																			name={[
																				name,
																				'ImageType',
																			]}
																			label="Select Image Type"
																			placeholder="Select Image Type"
																			onChange={
																				handleChange
																			}
																			options={{
																				rejected_keys:
																					isImageType3Selected && templeImageList[name]?.ImageType !== 3 ? [3] : [],
																				values: AUTH.lookupKeyList,
																				value_key:
																					'lookupIntValue',
																				text_key:
																					'lookupValue',
																			}}
																			rules={
																				templeRequest.imageType
																			}
																		/>
																	</Col>
																	<Col span={8}>
																		<InputComponent
																			required
																			name={[
																				name,
																				'Description',
																			]}
																			label="Image Description"
																			placeholder="Enter Image Description"
																			onChange={
																				handleChange
																			}
																			rules={
																				templeRequest.imgDescription
																			}
																		/>
																	</Col>
																	<Col span={6}>
																		<Form.Item
																			{...restField}
																			label={
																				'Select Image'
																			}
																			required
																		>
																			<Form.Item
																				{...restField}
																				name={[
																					name,
																					'fileList',
																				]}
																				noStyle
																			>
																				<Upload
																					onChange={
																						handleChange
																					}
																					name="file"
																					multiple={
																						false
																					}
																					accept={".jpeg, .jpg, .png, .webp, .jfif"}
																					listType="picture"
																					beforeUpload={(
																						file
																					) =>
																						beforeUpload(
																							file,
																							name
																						)
																					}
																					onRemove={() =>
																						handleRemove(
																							name
																						)
																					}
																					fileList={
																						fileLists[
																						name
																						] ||
																						[]
																					}
																					showUploadList={{
																						showRemoveIcon: false,
																					}}
																				>
																					{!fileLists[
																						name
																					] ||
																						fileLists[
																							name
																						]
																							.length ===
																						0 ? (
																						<Button
																							icon={
																								<FontAwesomeIcon
																									icon={
																										faPlus
																									}
																								/>
																							}
																						>
																							Upload
																						</Button>
																					) : null}
																				</Upload>
																			</Form.Item>
																		</Form.Item>
																	</Col>
																	<Col span={4}>
																		<Button
																			danger
																			style={{
																				marginBottom:
																					'12px',
																			}}
																			onClick={() => showConfirm(name)}
																		>
																			<FontAwesomeIcon
																				icon={
																					faMinus
																				}
																			/>
																		</Button>
																	</Col>
																</Row>
															</Col>
														);
													})}
												{
													!viewMode && (
														<Divider align="center">
															<Form.Item
																style={{
																	marginBottom: '0',
																}}
															>
																<Button
																	type="primary"
																	onClick={() => {
																		add();
																		handleChange();
																	}}
																	icon={
																		<FontAwesomeIcon
																			icon={
																				faPlus
																			}
																		/>
																	}
																>
																	Add Image Detail
																</Button>
															</Form.Item>
														</Divider>
													)
												}
											</Row>
										</>
									);
								}}
							</Form.List>
						</Col>
					</Row>
				</Spin>
			</Form>
		</div>
	);
});

export default TempleImageUpload;
